const doNothingEnhancer = (args) => args;
// support for devtools extension
export const HAS_REDUX_DEVTOOLS = Boolean(window.__REDUX_DEVTOOLS_EXTENSION__);
export const devtoolsReduxEnhancer = HAS_REDUX_DEVTOOLS ? window.__REDUX_DEVTOOLS_EXTENSION__() : doNothingEnhancer;
